var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isModalOpen)?_c('blok-modal',{attrs:{"open":_vm.isModalOpen,"blok":_vm.modalConfig}},_vm._l((_vm.blok.content),function(blokChild){return _c(_vm.dashify(blokChild.component),{key:blokChild._uid,tag:"component",attrs:{"blok":blokChild}})}),1):_vm._e(),_vm._v(" "),_c('blok-button',{attrs:{"blok":{
      action: 'openFormModal',
      name: 'Open Modal'
    }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }